import { useState, useEffect } from "react"

import ErrorMessage from "components/forms/error-message"
import lodash from "lodash"
import deepdash from "deepdash"
import { lang } from "config"
import Label from "components/forms/label"
import Input from "components/forms/input"
import useProductNeedRepositories from "repositories/product-need"
import Description from "components/forms/description"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import SelectDescription from "components/forms/select-description"
import { usePage } from "contexts/page-context"

export default function Form({ data, errors, onSubmit }) {
    const _ = deepdash(lodash)

    const { configuration } = usePage()

    const { data: productNeedSelection, isLoading: isLoadingProductNeedSelection } = useProductNeedRepositories({
        paginate: false
    })

    const id = data?.id

    const [name, setName] = useState(data?.name ?? null)
    const [productNeed, setProductNeed] = useState(data?.product_need?.id ?? null)

    const [productNeedObject, setProductNeedObject] = useState()

    useEffect(() => {
        if (data) {
            setName(data.name ?? null)
            setProductNeed(data.product_need.id ?? null)
        } else {
            if (!configuration('hierarchy').find((row) => row.key === 'product-need').value && configuration('hierarchy').find((row) => row.key === 'product-family').default_parent === 'auto' && !isLoadingProductNeedSelection) {
                setProductNeed(productNeedSelection[0]?.id)
            }
        }
    }, [data, isLoadingProductNeedSelection])

    useEffect(() => {
        if (productNeed && !isLoadingProductNeedSelection) {
            setProductNeedObject(productNeedSelection.find((row) => row.id === productNeed))
        }
    }, [productNeed, isLoadingProductNeedSelection])

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!nProgress.isStarted()) {
            onSubmit({
                id,
                name,
                product_need_id: productNeed,
                product_need: productNeedObject
            })
        } else {
            toast.error("Previous action is loading")
        }
    }
    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="mt-10 sm:mt-0">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="md:col-span-1">
                        <div className="px-4 sm:px-0">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">{lang.main_form}</h3>
                            <p className="mt-1 text-sm text-gray-600">{lang.please_fill_the_provided_form_input}</p>
                        </div>
                    </div>
                    <div className="mt-5 md:col-span-2 md:mt-0">
                        <div className="border sm:rounded-xl">
                            <div className="px-4 py-5 sm:p-6">
                                <div className="grid grid-cols-2 gap-4">
                                    {configuration('hierarchy').find((row) => row.key === 'product-need').value && (
                                        <div>
                                            <Label htmlFor="need" value="Product Need" />
                                            <SelectDescription onChange={(value) => setProductNeed(value)} selection={productNeedSelection} isLoading={isLoadingProductNeedSelection} value={productNeed} keyValue={(value) => value.id} title={(value) => value.name} placeholder="Select Product Need" />
                                            <ErrorMessage error={errors.product_need_id} />
                                        </div>
                                    )}
                                    <div>
                                        <Label htmlFor="name" value={lang.name} />
                                        <Input placeholder="Input name here" onChange={(e) => setName(e.target.value)} value={name} id="name" error={errors.name} />
                                        <Description error={errors.name} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-8 text-xs text-right">
                <button type="submit" className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{`${_.isEmpty(data) ? lang.create : lang.update}`}</span>
                </button>
            </div>
        </form>
    )
}